// Keep the same coordinate system when returning to Home with browser chrome
// in a different state. Only a width/orientation change replaces a touch layout.
const touchLayouts = new Map();

export function createHomeViewport(cache = new Map()) {
  return ({ width, height, touch, orientation = '' }) => {
    const key = `${width}:${orientation}`;
    if (touch && cache.has(key)) return cache.get(key);
    const size = { width, height };
    if (touch && width > 0 && height > 0) cache.set(key, size);
    return size;
  };
}

export function watchHomeViewport(root) {
  const resolve = createHomeViewport(touchLayouts);
  const probe = document.createElement('div');
  probe.setAttribute('aria-hidden', 'true');
  probe.style.cssText = 'position:fixed;inset:0 auto auto 0;width:0;height:100svh;visibility:hidden;pointer-events:none;';
  document.body.appendChild(probe);
  let current;
  let frame;
  function measure() {
    const next = resolve({
      width: document.documentElement.clientWidth,
      height: probe.getBoundingClientRect().height || window.innerHeight,
      touch: matchMedia('(any-pointer: coarse)').matches,
      orientation: window.screen.orientation?.type || String(window.orientation ?? ''),
    });
    if (next.height > 0 && (next.height !== current?.height || next.width !== current?.width)) {
      root.style.setProperty('--home-vh', `${next.height / 100}px`);
      current = next;
    }
  }
  function queue() {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(measure);
  }
  measure();
  // Commit before the motion listeners compare dimensions or destinations.
  window.addEventListener('resize', measure, { passive: true });
  window.addEventListener('orientationchange', queue, { passive: true });
  return () => {
    cancelAnimationFrame(frame);
    window.removeEventListener('resize', measure);
    window.removeEventListener('orientationchange', queue);
    probe.remove();
  };
}
